import { Link } from "react-router-dom";
import styles from "./style.module.scss";
import { Col, ColProps } from "reactstrap";
import cx from "classnames";
import { HTMLAttributeAnchorTarget } from "react";

type HeaderLinkProps = {
  children?: React.ReactNode;
  icon: string,
  iconAlt: string,
  to: string,
  target?: HTMLAttributeAnchorTarget | undefined;
  linkClassName?: string
  iconClassName?: string
} & ColProps;

const DashboardLink = (props: HeaderLinkProps) => {
  const { icon, to, target, iconAlt, children, linkClassName, iconClassName, ...rest } = props;

  return (
    <Col
      xs="4"
      sm="2"
      xl="1"
      {...rest}
    >
      <Link className={cx([styles.link, linkClassName])} target={target} to={to}>
        <img className={cx([styles.icon, iconClassName])} src={icon} alt={iconAlt} />
        {children}
      </Link>
    </Col>

  )
}

export default DashboardLink;